export const FENCE_COLORS = {
	PRIMARY: "#2E90FA",
	PRIMARY_FILL: "#2E90FA",
	MARKER_STROKE: "#A4A7AE",
	MARKER_FILL: "#fff",
} as const;

export const CIRCLE_WKT_REGEX =
	/CIRCLE\s*\(\s*([-\d.]+)\s*,\s*([-\d.]+)\s*,\s*(\d+(?:\.\d+)?)\s*\)/i;

export const CIRCLE_SIMPLE_REGEX =
	/^([-\d.]+)\s+([-\d.]+)\s*,\s*(\d+(?:\.\d+)?)$/;

export const POLYGON_WKT_REGEX = /POLYGON\s*\(\s*\(\s*(.+)\s*\)\s*\)/i;

export const POLYGON_SIMPLE_REGEX = /^\(\s*(.+)\s*\)$/;

export const WHITESPACE_SPLIT_REGEX = /\s+/;

export const FENCE_TYPE_LABELS = {
	1: "Círculo",
	2: "Polígono",
} as const;

export const FENCE_TYPE_ICONS = {
	1: "circle",
	2: "polygon",
} as const;

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;
export const QUERY_STALE_TIME_MS = 1000 * 30;

export const DRAW_PATH_OPTIONS = {
	color: FENCE_COLORS.PRIMARY,
	fillColor: FENCE_COLORS.PRIMARY_FILL,
	fillOpacity: 0.2,
	weight: 2,
} as const;

export const EDITABLE_EVENTS = [
	"editable:dragend",
	"editable:vertex:dragend",
	"editable:vertex:new",
	"editable:vertex:deleted",
	"editable:editing",
] as const;
